<template>
  <div class="home">
    <!-- <div id="fb-root"></div> -->
    <header id="top-head" class="header">
      <h1><a class="header__logo" href="#" v-scroll-to="'#app'">松本文字塾第二期 文字塾展東京出張版「どこまでも もじはつづくよ かなの旅」</a></h1>
      <nav id="global-nav" class="global__nav">
        <a href="#period" class="gnav__item gnav__01">会期</a>
        <a href="#about" class="gnav__item gnav__02">展示について</a>
        <a href="#pamphlet" class="gnav__item gnav__03">冊子</a>
        <a href="#talkevent" class="gnav__item gnav__04">トークイベント</a>
        <a href="#access" class="gnav__item gnav__05">アクセス</a>
        <a href="#qanda" class="gnav__item gnav__06">Q&amp;A</a>
      </nav>

      <div class="navbar-end">
        <b-dropdown aria-role="list" :mobile-modal="false" position="is-bottom-left">
          <button class="button is-primary" slot="trigger" slot-scope="{ active }">
            <span class="header__dropdownbtn__icon" :class="active ? 'menu-up' : 'menu-down'">▼</span>
          </button>

          <b-dropdown-item aria-role="listitem" href="#period" class="gnav__item gnav__01">会期</b-dropdown-item>
          <b-dropdown-item aria-role="listitem" href="#about" class="gnav__item gnav__02">展示について</b-dropdown-item>
          <b-dropdown-item aria-role="listitem" href="#pamphlet" class="gnav__item gnav__03">冊子</b-dropdown-item>
          <b-dropdown-item aria-role="listitem" href="#talkevent" class="gnav__item gnav__04">トークイベント</b-dropdown-item>
          <b-dropdown-item aria-role="listitem" href="#access" class="gnav__item gnav__05">アクセス</b-dropdown-item>
          <b-dropdown-item aria-role="listitem" href="#qanda" class="gnav__item gnav__06">Q&amp;A</b-dropdown-item>

        </b-dropdown>
      </div>

    </header>

    <div class="mainContent">
      <section class="topimg">
        <div class="landscape" role="img" aria-label="img">
          <div class="landscape__layer">
            <div class="landscape__title" style="--offset: 1">
              <img src="../assets/img/top/title.svg" alt="どこまでも もじはつづくよ かなの旅">
          </div>
          <div class="landscape__layer" style="--offset: 0.6">
            <div class="landscape__image">
              <img src="../assets/img/top/mountain.svg" alt="山並み">
            </div>
          </div>
          <div class="landscape__layer" style="--offset: 0.4">

            <div class="landscape__image">
              <img src="../assets/img/top/range_full.svg" alt="山脈">
            </div>
          </div>

            <!-- <div class="landscape__mojijuku">
              <img src="../assets/img/top/mojijuku.svg" alt="松本文字塾第二期">
            </div> -->
          </div>
        </div>
      </section>

      <section class="period">
        <div class="period">
          <h2 class="title h2">会期<a id="period" class="hash_anchor"></a></h2>
          <p class="date">
            <span>2024</span>年
            <span>11</span>月
            <span>9</span>日（土）
            <span>・10</span>日（日）
            <span>・16</span>日（土）
            <span>・17</span>日（日）<br>
          </p>

          <div class="columns timetable">
            <div class="column student">
              <div class="text mt-0">
                <div class="namejob">
                  <div class="name">11月9日・10日・17日</div>
                  <div class="centerLine"><hr></div>
                  <div class="job">12:00 – 18:00</div>
                </div>
                <div class="namejob with--description">
                  <div class="name">11月16日</div>
                  <div class="centerLine"><hr></div>
                  <div class="job">12:00 – 14:00</div>
                </div>
                <div class="description">トークイベント 14:00 – 17:00</div>
              </div>
            </div>
          </div>
          <p><span class="is-hidden-mobile">会場：</span><a target="_blank" href="https://book-design.jp/">Book&amp;Design</a>（東京都台東区浅草）</p>

          <p class="caption is-size-6 mt-7">
            ＊展示は入場無料です。<br/>
            ＊土・日のみ開場します。平日およびトークイベント中は閉場しますのでご注意ください。
          </p>

        </div>
        <!-- <div class="period">
          <p class="date mt-6" v-if="sessionalStatus === 'pre'" v-html="startDateCountDownStr"></p>
          <p class="caption has-text-centered" v-if="sessionalStatus === 'pre'">作品の展示は<span v-text="$store.getters['getStartDate'].format('M月D日HH:mm')"></span>から<span v-text="$store.getters['getEndDate'].format('M月D日HH:mm')"></span>の間、会場でのみ公開されます。期間中はぜひ会場へお越しください。</p>
          <p class="caption has-text-centered" v-if="sessionalStatus === 'post'">作品の展示は<span v-text="$store.getters['getEndDate'].format('M月D日')"></span>をもちまして終了いたしました。たくさんのご来場・視聴をいただきましてありがとうございました。</p>
          <p class="caption has-text-centered" v-if="sessionalStatus === 'mid'">作品の展示は<span v-text="$store.getters['getStartDate'].format('M月D日HH:mm')"></span>から<span v-text="$store.getters['getEndDate'].format('M月D日')"></span>の期間のみ公開されます。作品は作品閲覧からご覧ください。作品の解説は動画解説をご覧ください。</p>
        </div> -->
      </section>

      <section class="about">
        <h2 class="title h2">展示について<a id="about" class="hash_anchor"></a></h2>
        <div class="columns is-desktop about__description">
          <div class="column torinoumimessage">
            <h3 class="h3">文字塾展東京出張版ご挨拶</h3>
            <div class="is-serif">
              <p>文字塾は、参加する塾生が１年をかけてそれぞれの明朝体の仮名をデザインする私塾です。東京を拠点に８年ほど実施していましたが、コロナ禍を機に私が長野県安曇野市へ住居を移したことに伴い、2022年4月から長野県松本市に拠点を移し、松本文字塾として再スタートしました。今回はその２期目となります。13名の国内の参加者に加え、中国から１名、台湾から２名の計16名の参加となりました。</p>
              <p>コンセプト作りからはじまり、ラフスケッチを経由して、デッサンと私からのアドバイスを繰り返し、頭を抱え、気付き、そしてまた悩みつつ、なんとか今回展示した作品まで漕ぎつけました。プロの方もいるし、プロ顔負けの人もいます。どうしても上手くいかず、時間切れで不本意に終わった人もいます。でもね、そうした経験が身になるんですよ。上手くできた人も、思うようにできなかった人も、しっかりと歩んでいくことを心から祈ってます。ここに展示した作品はそういう作品です。多くのみなさまに暖かい目で観てもらえたら幸いです。</p>
              <p>また、11月16日（土）には、アドビ社の日本語タイポグラフィのシニアデザイナー西塚涼子さんをお招きして、作品への感想はもちろん、ご自身の書体制作への向き合い方や考えていることなどを、ざっくばらんに明るく楽しくお聞きしたいと思います。</p>
              <p class="has-text-right is-serif mt-7">松本文字塾塾長　鳥海修</p>
            </div>
          </div>
          <div class="column student">
            <h3 class="h3">参加者</h3>
            <div class="namejob">
              <div class="name">稲岡莉々</div>
            </div>
            <div class="namejob">
              <div class="name">落合あや子</div>
            </div>
            <div class="namejob">
              <div class="name">佐藤美羽</div>
            </div>
            <div class="namejob">
              <div class="name">篠鉄平</div>
            </div>
            <div class="namejob">
              <div class="name">朱心茹</div>
            </div>
            <div class="namejob">
              <div class="name">榛葉眞利子</div>
            </div>
            <div class="namejob">
              <div class="name">鈴木彩恵実</div>
            </div>
            <div class="namejob">
              <div class="name">曾國榕</div>
            </div>
            <div class="namejob">
              <div class="name">高橋さくら</div>
            </div>
            <div class="namejob">
              <div class="name">田中千尋</div>
            </div>
            <div class="namejob">
              <div class="name">都筑尭志</div>
            </div>
            <div class="namejob">
              <div class="name">舟山貴士</div>
            </div>
            <div class="namejob">
              <div class="name">前田凜</div>
            </div>
            <div class="namejob">
              <div class="name">松本向日葵</div>
            </div>
            <div class="namejob">
              <div class="name">山田紗愛</div>
            </div>
            <div class="namejob">
              <div class="name">林芳平</div>
              <span class="is-size-7">（五十音順、計16名）</span>
            </div>

            <h3 class="h3__margin">協力</h3>
            <div class="namejob">
              <div class="name"><a href="https://book-design.jp/" target="_blank">Book&amp;Design</a></div>
              <div class="name"><a href="https://matsumototypography.jpn.org/" target="_blank">松本タイポグラフィ研究会</a></div>
            </div>
            <!-- <div class="text is-size-8">
              稲岡莉々・落合あや子・佐藤美羽・篠鉄平・朱心茹・榛葉眞利子・鈴木彩恵実・曾國榕・高橋さくら・田中千尋・都筑尭志・舟山貴士・前田凜・松本向日葵・山田紗愛・林芳平
              <span class="is-size-7">（五十音順、計16名）</span> -->

              <!-- <div class="namejob">
                <div class="name">本間由夏</div>
                <div class="centerLine"><hr></div>
                <div class="job">〇〇〇〇〇〇〇〇〇〇</div>
                <p class="is-size-7">※五十音順、計16名、2023年6月現在</p>
              </div> -->

            <!-- </div> -->
          </div>
        </div>
      </section>

      <!-- <section class="works">
        <h2 class="h1">作品展示<a id="works" class="hash_anchor"></a></h2>
        <p class="date" v-if="sessionalStatus === 'pre'" v-html="startDateCountDownStr"></p>
        <p class="caption is-serif has-text-centered" v-if="sessionalStatus === 'pre'">作品の展示は<span v-text="$store.getters['getStartDate'].format('M月D日HH:mm')"></span>から<span v-text="$store.getters['getEndDate'].format('M月D日')"></span>の期間のみ公開されます。<br>展示公開日までお待ちください。</p>
        <p class="caption is-serif" v-if="sessionalStatus === 'post'">作品の展示は<span v-text="$store.getters['getEndDate'].format('M月D日')"></span>をもちまして終了いたしました。たくさんのご来場・視聴をいただきましてありがとうございました。</p>
        <p class="caption is-serif" v-if="sessionalStatus === 'mid'">作品の展示は<span v-text="$store.getters['getStartDate'].format('M月D日HH:mm')"></span>から<span v-text="$store.getters['getEndDate'].format('M月D日')"></span>の期間のみ公開されます。作品は作品閲覧からご覧ください。作品の解説は動画解説をご覧ください。</p> -->
        <!-- <img src="../assets/img/2020-05-06_23h06_38.png" alt="" class="works__thumbnail"> -->
        <!-- <div class="button__wrapper" v-if="sessionalStatus === 'mid'">
          <button class="button" @click="showWorksModal">作品閲覧</button>
          <a href="https://youtu.be/kbLzqaElnnU" target="_blank" class="button">動画解説</a>
        </div> -->
      <!-- </section> -->

      <section class="eyecatch">
        <div class="slideshow"></div>
        <div class="slideshow slideshow2"></div>
        <!-- <img src="../assets/img/eyecatch.jpg" class="scene"> -->
      </section>

      <section class="pamphlet">
        <h2 class="h2">冊子<a id="pamphlet" class="hash_anchor"></a></h2>
        <div class="pamphlet__thumbnail__wrap">
          <img src="../assets/img/pamphlet/pamphlet--01.png" srcset="../assets/img/pamphlet/pamphlet--01.png 1x, ../assets/img/pamphlet/pamphlet--01@2x.png 2x" alt="">
        </div>
        <p class="caption is-serif">制作書体と組見本を収録した冊子を会場にご用意（A4変型／約80ページ）。制作者による書体紹介、小宮山博史さんによる講評、塾長からのコメント等を掲載しています。ご来場の際、お一人様1冊お持ち帰りいただけます。数に限りがあります。無くなりました場合にはご容赦ください。</p>
        <div class="typeface__commentator">
          <div class="columns is-desktop profile__title">
            <div class="column">
              <div class="columns">
                <div class="column is-one-quarter-desktop is-one-third-tablet is-hidden-mobile">
                  <img src="../assets/img/profile/komiyama.jpg" alt="小宮山博史" class="profile__thumbnail">
                </div>
                <div class="column">
                  <h3 class="h3">小宮山博史<span class="is-small">（こみやまひろし）</span></h3>
                  <p class="is-serif calt komiyama__profile">1943年新宿早稲田生まれ。佐藤敬之輔に師事し書体史と書体設計の基礎を学ぶ。元佐藤タイポグラフィ研究所代表。調査・研究と称してしばしば上海に遊び、美華書館の足跡を探す。著書に『<a href="https://ndlsearch.ndl.go.jp/books/R100000002-I000002823739" target="_blank">明朝体活字字形一覧</a>』、『<a href="https://ndlsearch.ndl.go.jp/books/R100000002-I000009993594" target="_blank">日本語活字ものがたり</a>』、『<a href="http://www.graphicsha.co.jp/detail.html?p=42704" target="_blank">明朝体活字</a>』などがある。横浜市在住。</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <h3 class="h3">冊子申込受付期間（第二期受付）</h3>
        <p class="date date--small"><span v-text="$store.getters['getPamphletOrderStartDate'].format('YYYY')"></span>年<span v-text="$store.getters['getPamphletOrderStartDate'].format('M')"></span>月<span v-text="$store.getters['getPamphletOrderStartDate'].format('D')"></span>日（{{$store.getters['getPamphletOrderStartDate'].format('ddd')}}）<span v-text="$store.getters['getPamphletOrderStartDate'].format('HH:mm')"></span><span> – </span><br class="is-hidden-tablet"><span v-text="$store.getters['getPamphletOrderEndDate'].format('M')"></span>月<span v-text="$store.getters['getPamphletOrderEndDate'].format('D')"></span>日（{{$store.getters['getPamphletOrderEndDate'].format('ddd')}}）<span v-text="$store.getters['getPamphletOrderEndDate'].format('HH:mm')"></span></p> -->
        <!-- <p class="note">先着200名、1名1冊まで・フォーム送信後に送料として300円を指定口座までお振込いただきます。<br>期日前でも申込数が在庫に達し次第申込フォームの受付を終了します。</p> -->
        <!-- <div class="button__wrapper" v-if="pamphletOrderlStatus === 'mid'">
          <a class="button button--narrowpadding" href="https://docs.google.com/forms/d/e/1FAIpQLSdj7FkRRdB1O0EfaaYdjuM1ZxOn8mn2jNO64mxqZoOJtN4oSQ/viewform" target="_blank">冊子申込フォーム</a>
        </div> -->
      </section>

      <section class="talkevent">
        <h2 class="title h2">トークイベント<a id="talkevent" class="hash_anchor"></a></h2>
        <h3 class="h1">松本文字塾の一年間を振り返る<br>―西塚涼子氏をお迎えして―</h3>
        <!-- <h3 class="h1" v-if="sessionalStatus === 'mid'"><a href="https://youtu.be/4XufyzoFEc8" target="_blank"><span class="is-hidden-mobile">『</span>今田欣一<br class="is-hidden-tablet">×<br class="is-hidden-tablet">文字塾<span class="is-hidden-mobile">』</span></a></h3> -->

        <div class="caption is-serif mt-7"><p>文字塾の先輩でもある西塚涼子さんをゲストにお迎えし、トークイベントを開催いたします。</p><p>塾生が自身の制作書体や松本文字塾の感想を発表し、西塚さん・塾長を交えてディスカッションすることで、文字塾や松本での文字作りといった角度から作品を掘り下げていきます。参加者からの質疑応答も予定しております。当日はご参加をお待ちしております。</p>
        <!-- <p>また、トークイベント終了後、参加者の皆さまと文字塾生の交流の場として懇親会を開催いたします。懇親会はどなたでもご参加いただけますが、お申し込みが必要です。トークイベントの参加お申し込み時に開催情報をご確認の上、ぜひお申し込みください。</p> -->
        </div>

        <h3 class="h3">日時</h3>
        <p class="date"><span v-text="$store.getters['getTalkEventStartDate'].format('YYYY')"></span>年<span v-text="$store.getters['getTalkEventStartDate'].format('M')"></span>月<span v-text="$store.getters['getTalkEventStartDate'].format('D')"></span>日（{{$store.getters['getTalkEventStartDate'].format('ddd')}}）<br class="is-hidden-tablet"><span v-text="$store.getters['getTalkEventStartDate'].format('HH:mm')"></span><span> – </span><span v-text="$store.getters['getTalkEventEndDate'].format('HH:mm')"></span></p>

        <p class="caption">事前予約制／先着20名様<br>参加費：一般 2,500円／学生 2,000円<br>（現金のみ／当日会場受付にてお支払いください）<br>お申し込み受付は9月30日（月）から開始<span class="is-hidden-desktop"><br></span>（定員に達し次第締切）</p>
        <p class="mt-4 caption notes">＊トークイベント終了後、参加者の皆さまと文字塾生の交流の場として懇親会を開催します。<br/>トークイベントお申し込み時に開催情報をご確認の上、ぜひお申し込みください。</p>
        <div class="button__wrapper" v-if="sessionalStatus === 'pre'">
          <b-field><b-tag type="is-warning"><span>お申し込み受付開始まで今しばらくお待ち下さい</span></b-tag></b-field>
        </div>
        <div class="button__wrapper" v-if="sessionalStatus === 'mid'">
          <a class="button is-link" href="https://forms.gle/qCV4QZq5Ei1wsRTM9" target="_blank">トークイベントを予約する</a>
        </div>
        <div class="button__wrapper" v-if="sessionalStatus === 'post'">
          <b-field><b-tag type="is-warning"><span class="is-size-7-mobile">受付を締め切りました。お申し込みありがとうございました。</span></b-tag></b-field>
        </div>

        <div class="talk__guest">
          <div class="columns is-desktop profile__title">
            <div class="column">
              <div class="profile__thumbnail__wrap is-hidden-mobile">
                <img src="../assets/img/profile/torinoumi.jpg" alt="鳥海修" class="profile__thumbnail">
              </div>
              <h3 class="h3">鳥海修<span class="is-small">（とりのうみおさむ）</span></h3>
              <p class="is-serif calt">1955年山形県生まれ。<a href="http://www.jiyu-kobo.co.jp/" target="_blank">（有）字游工房</a>の書体設計士。同社の游明朝体、游ゴシック体、（株）SCREENホールディングスのヒラギノシリーズ、こぶりなゴシックなど100書体以上の開発に携わる。字游工房として2002年に第1回佐藤敬之輔賞、ヒラギノシリーズで2005年グッドデザイン賞、2008東京TDC タイプデザイン賞を受賞。2024年、日本文化の向上につくしたとして第58回吉川英治文化賞を受賞。2022年dddギャラリーで個展「もじのうみ」を開催。著書に『<a href="https://www.shobunsha.co.jp/?p=4004" target="_blank">文字を作る仕事</a>』（日本エッセイスト・クラブ賞受賞）、『<a href="http://www.kawade.co.jp/np/isbn/9784309256276/" target="_blank">本をつくる</a>』（共著）、『<a href="https://book-design.jp/works/602/" target="_blank">明朝体の教室</a>』がある。2021年に長野県安曇野市に移住。私塾「<a href="https://www.mojijuku.jp/">松本文字塾</a>」塾長。</p>
            </div>
            <div class="column">
              <div class="profile__thumbnail__wrap is-hidden-mobile">
                <img src="../assets/img/profile/nishizuka.png" alt="西塚涼子" class="profile__thumbnail">
              </div>
              <h3 class="h3">西塚涼子<span class="is-small">（にしづかりょうこ）</span></h3>
              <p class="is-serif calt">1972年福島県生まれ。アドビ Adobe Type プリンシパルデザイナー。武蔵野美術大学 造形学部 視覚伝達デザイン学科卒業。1997年アドビシステムズに入社。小塚昌彦氏の指導の下、「小塚明朝」、「小塚ゴシック」の開発に携わる。その後、様々なアドビオリジナル書体を制作し「かづらき」、「源ノ角ゴシック／Source Han Sans／Noto Sans CJK」、「貂明朝」、「ヒグミン」、「貂明朝アンチック」などをリリース。「貂明朝」は2015年の文字塾で制作した「貂々明朝」がベースになっている。現在は縦横比が可変のバリアブルフォント「百千鳥（ももちどり）」の仕上げに取り組んでいる。</p>
            </div>
          </div>
        </div>

      </section>

      <div class="fullwidth--wrap bgc">
        <section class="access">
          <h2 class="h2">アクセス<a id="access" class="hash_anchor"></a></h2>
          <div class="columns is-desktop">
            <div class="column">
              <div class="upper__wrap">
                <div class="map__wrap">
                  <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12958.10653260661!2d139.7978193!3d35.7132647!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188ec144b07e5b%3A0xc6c6ea44eee7d4a0!2sBook%20%26%20Design!5e0!3m2!1sen!2sjp!4v1726973590762!5m2!1sen!2sjp" width="750" height="400" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
              </div>
              <div class="text__wrap">
                <p class="is-size-5-mobile is-size-4"><a target="_blank" href="https://book-design.jp/">Book&amp;Design</a></p>
                <p class="mt-5">〒111-0032　<span class="is-hidden-tablet"><br></span>東京都台東区浅草2丁目1-14 3階 Book&amp;Design</p>
                <p class="is-size-6 mt-2">＊浅草駅（銀座線・東武スカイツリーライン・浅草線）から徒歩約5分<br>
                ＊エレベーターはありません。階段で3階にお上りください。<br>
                ＊お車でお越しの場合は近隣のコインパーキングをご利用ください。</p>
              </div>
            </div>
          </div>
        </section>
      </div>

      <section class="qanda">
        <h2 class="h2">Q&amp;A<a id="qanda" class="hash_anchor"></a></h2>
        <div class="qawrap">
          <h3 class="h3">松本文字塾第二期 文字塾展（2024年6月開催）と内容は異なりますか？</h3>
          <p class="caption is-serif">より多くの方に楽しんでいただけるよう、松本での展示内容をほぼまるごと東京へ持ってきました。松本での展示と同様に、各作品の組見本、字形一覧および制作ファイルを展示します。</p>
        </div>
        <div class="qawrap">
          <h3 class="h3">オンラインでの作品展示やトークイベントの配信はありますか？</h3>
          <p class="caption is-serif">会期中のオンラインでの作品掲示やトークイベントの配信は予定されておりません。ぜひ会期中に会場へお越しください。</p>
        </div>
        <div class="qawrap">
          <h3 class="h3">冊子はどこで入手できますか？</h3>
          <p class="caption is-serif">会期中に展示会場でご入手いただけます。その他での頒布は現在予定しておりません。また数に限りがあるためお一人様1冊とさせていただきます。予めご了承ください。</p>
        </div>
        <div class="qawrap">
          <h3 class="h3">会場内の撮影は可能ですか？</h3>
          <p class="caption is-serif">パネルを含む会場内の撮影は原則自由となります。作品ファイルの撮影は不可です。展示スタッフから指示がある場合は指示に従ってください。トークイベントでの撮影については当日のアナウンスに従ってください。</p>
        </div>
        <div class="button__wrapper"><a href="https://forms.gle/Ttgw5X7X6ncyzaaK8" target="_blank" class="button is-link">文字塾展東京出張版について問い合わせる</a></div>
      </section>

      <footer>Copyright © Mojijuku All rights reserved.<br>当サイトに掲載されている文章及び画像の無断利用を禁じます。</footer>
    </div>
  </div>
</template>

<script>

import dayjs from 'dayjs'
import 'dayjs/locale/ja'
dayjs.locale('ja')
const duration = require('dayjs/plugin/duration')
dayjs.extend(duration)

setInterval(function () {//一秒間に一回再取得

}, 1000);

// For scroll animation

// constant elements: your main scrolling element; html element
const scrollEl = document.documentElement;
const root = document.documentElement;

let scrollPos;

// update css property on scroll
function animation() {
  // check the scroll position has changed
  if (scrollPos !== scrollEl.scrollTop) {
    // reset the seen scroll position
    scrollPos = scrollEl.scrollTop;
    // update css property --scrollPos with scroll position in pixels
    root.style.setProperty('--scrollPos', scrollPos + 'px');
  }

  // call animation again on next animation frame
  window.requestAnimationFrame(animation);
}

// start animation on next animation frame
window.requestAnimationFrame(animation);


export default {
  name: 'Home',
  components: {
  },
  computed: {
    startCountDownChanges: {
      get : function(){
        return this.startDateCountDownStr;
      },
      set : function(v){
        this.startDateCountDownStr =  v;
      }
    },
    sessionalStatus() {
      const nowDate = dayjs()
      let   thisSessionalStatus = 'pre';
      if (nowDate.isAfter(this.$store.getters['getTalkEventBookStartDate'])) {
        // 開始日以降
        if (nowDate.isBefore(this.$store.getters['getTalkEventBookEndDate'])) {
          // 終了日以前
          thisSessionalStatus = 'mid';
        } else {
          // 終了日以降
          thisSessionalStatus = 'post';
        }
      } else {
        // 開始日以前
        thisSessionalStatus = 'pre';
      }
      // メンバープレビュー用
      if (this.$route.name === 'Home-mid') {
        thisSessionalStatus = 'mid';
        console.log('mid')
      } else if(this.$route.name === 'Home-post') {
        thisSessionalStatus = 'post';
        console.log('post')
      }
      this.$store.dispatch('updateSessionalStatus', thisSessionalStatus)
      return this.$store.getters['getSessionalStatus']
    },
    time() {
      return this.$store.state.eventStartDate.format('HH:mm:ss')
    },
    pamphletOrderlStatus() {
      const nowDate = dayjs()
      let   thisPamphletOrderStatus = 'pre';
      if (nowDate.isAfter(this.$store.getters['getPamphletOrderStartDate'])) {
        // 開始日以降
        if (nowDate.isBefore(this.$store.getters['getPamphletOrderEndDate'])) {
          // 終了日以前
          thisPamphletOrderStatus = 'mid';
        } else {
          // 終了日以降
          thisPamphletOrderStatus = 'post';
        }
      } else {
        // 開始日以前
        thisPamphletOrderStatus = 'pre';
      }
      // メンバープレビュー用
      if (this.$route.name === 'Home-mid') {
        thisPamphletOrderStatus = 'mid';
      } else if(this.$route.name === 'Home-post') {
        thisPamphletOrderStatus = 'post';
      }
      this.$store.dispatch('updatePamphletOrderStatus', thisPamphletOrderStatus)
      return this.$store.getters['getPamphletOrderStatus']
    },
  },
  mounted: function(){
    this.updateStartCountDownChanges();
  },
  beforeDestroy () {
    clearInterval(this.startDateCountDownInterval)
  },
  methods: {
    // 作品閲覧クリック用method
    showWorksModal () {
      this.$store.dispatch('updateIsWorksModalActive', true)
      this.isWorksModalActive = true
      this.$gtag.event('modal', { method: 'showWorksList' })
    },
    hideWorksModal () {
      this.$store.dispatch('updateIsWorksModalActive', false)
      this.isWorksModalActive = false
    },
    afterEnter () {
      this.isWorksModalActive = this.$store.getters['getIsWorksModalActive']
    },
    afterLeave () {
      // this.$root.$emit('triggerScroll')
    },
    updateStartCountDownChanges (){
      this.startDateCountDownInterval = setInterval(function(){
        // diffメソッドを使って、日時の差を、ミリ秒で取得
        const diff = this.$store.getters['getStartDate'].diff( dayjs() );

        // ミリ秒からdurationオブジェクトを生成
        const duration = dayjs.duration( diff );

        // 日・時・分・秒を取得
        const days = Math.floor( duration.asDays());
        const hours   = duration.hours();
        const minutes = duration.minutes();
        const seconds = duration.seconds();
        const nowDate = dayjs()
        if (days < 0 && hours < 0 && minutes < 0 && seconds < 0) {
          if (nowDate.isAfter(this.$store.getters['getStartDate'])) {
            if (nowDate.isBefore(this.$store.getters['getEndDate'])) {
              this.$store.dispatch('updateSessionalStatus', 'mid')
            } else {
              this.$store.dispatch('updateSessionalStatus', 'post')
            }
          }
        }

        //カウントダウンの結果を変数に代入
        this.startCountDownChanges = '開催まであと<br><span>' + days + '</span>日<span>' +  hours + '</span>時間<span>' + minutes + '</span>分<span>' + seconds + '</span>秒';
      }.bind(this), 1000);
    }
  },
  data() {
    return {
      isWorksModalActive: this.$store.getters['getIsWorksModalActive'],
      startDateCountDownStr: '',
      startDateCountDownInterval: undefined,
    }
  }
}
</script>
